import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component that scrolls the window to the top for Admin routes only.
 * This ensures users start at the top of the page when navigating between Admin pages,
 * especially important on mobile devices where scroll position can persist after
 * clicking tiles on the Admin landing page.
 * 
 * Must be placed inside a Router component to access location.
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Only scroll to top for admin routes
    if (pathname.startsWith('/admin')) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
